import React from 'react';
import { AppPageTitles } from '../../environment/app-page-titles'
import useDocumentTitle from '../../hooks/usePageTitle'
import DocsToDownloadPageBanner from './DocsToDownloadPageBanner/DocsToDownloadPageBanner'
import DocsToDownloadPageContent from './DocsToDownloadPageContent/DocsToDownloadPageContent'

import './DocsToDownloadPageStyles.scss'

const DocsToDownloadPage = () => {

   useDocumentTitle(AppPageTitles.docsToDownload)

   return (
      <>
         <DocsToDownloadPageBanner />
         <main className='docs-to-download-page-main-content-wrapper'>
            <DocsToDownloadPageContent />
         </main>
      </>
   )
}

export default DocsToDownloadPage